module.exports = __webpack_public_path__ + "static/img/homePlan1.56f0211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homePlan1.png
// module id = Kyo/
// module chunks = 3